import { TFunction } from 'i18next'
import { Params } from 'react-router'
import { ExternalScriptsFunction, ScriptDescriptor } from 'remix-utils/external-scripts'

import { Flags } from './flags'
import { LayoutType, PageLayouts } from './layout'
import { UserInfo } from './user'
import { MODE } from '~/components/DarkMode/constants'
import { SessionNotificationConfig } from '~/types/notifications'
import {
  ApiHubPlan,
  PORTAL_LICENSE_STATE,
  PORTAL_LICENSE_TYPE,
  PortalLicense,
  SWAGGERHUB_PLAN_TYPE,
  SWAGGERHUB_ROLE
} from '~/types/portal'

export interface PendoOptions {
  _q: string[][]
  identify?: () => void
  initialize?: (data: object) => void
  pageLoad?: () => void
  track?: () => void
  updateOptions?: () => void
}

export interface PendoPortalData {
  portalSubdomain: string,
  portalType: PORTAL_LICENSE_TYPE,
  portalState: PORTAL_LICENSE_STATE,
  swaggerHubOrgId: string,
  swaggerHubOrgName: string,
  swaggerHubLicense: SWAGGERHUB_PLAN_TYPE,
  platformManaged: boolean,
}

export interface PendoData {
  pendoApiKey: string;
  portalData?: Partial<PendoPortalData>;
}

export interface PortalData {
  subdomain: string;
}

export interface AppConfig {
  platformUiUrl: string;
  shubExploreUrl: string;
  pactflowAppUrl: string;
  reflectAppUrl: string;
  shubAppUrl: string;
  portalRootUrl: string;
}

export interface AppLoaderData {
  locale: string;
  notification: SessionNotificationConfig | null;
  env: Environment;
  bugsnagApiKey: string;
  user: UserInfo;
  layout: LayoutType;
  organizationRole?: SWAGGERHUB_ROLE;
  pendoData?: PendoData;
  portalData?: PortalData;
  mode?: MODE;
  preferredColorScheme?: MODE.LIGHT | MODE.DARK;
  license?: PortalLicense;
  apiHubPlan?: ApiHubPlan;
  appConfig: AppConfig;
  flags: Flags;
  swaggerhubOrgId?: string;
  portalMetaName?: string;
  apiHubUrl?: string;
  appToken?: string;
  cutoverDate?: string;
  editorKey?: string;
}

export interface ActionResponse {
  success: boolean;
  statusCode?: number;
}

export enum Environment {
  LOCAL = 'local',
  DEV = 'dev',
  INT = 'int',
  PROD = 'prod',
  ON_PREM = 'onprem',
}

export interface PortalRouteMatch<T = any> {
  data: T;
  id: string;
  pathname: string;
  params: Params<string>;
  handle: any;
}

export interface BreadcrumbParams<T = any> {
  match: PortalRouteMatch<T>;
  t: TFunction;
}

export interface PortalRouteHandle<T = any> {
  breadcrumb?: (params: BreadcrumbParams<T>) => string
  layout?: PageLayouts,
  scripts?: ExternalScriptsFunction<T> | ScriptDescriptor[],
}

export interface MetaInfo {
  canonicalUrl: string;
  pageUrl: string;
  title?: string;
}